var React = require('react');

function WorkoutIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M30.086 6.93333V9.06666H27.937V13.3333H25.788V15.4667H22.5645V9.06666H7.52132V15.4667H4.29779V13.3333H2.14878V9.06666H-0.000244141V6.93333H2.14878V2.66666H4.29779V0.533325H7.52132V6.93333H22.5645V0.533325H25.788V2.66666H27.937V6.93333H30.086Z","fill":"current"}));
}

WorkoutIcon.defaultProps = {"width":"31","height":"16","viewBox":"0 0 31 16","fill":"none"};

module.exports = WorkoutIcon;

WorkoutIcon.default = WorkoutIcon;
